export default "__VITE_ASSET__c23868ec__"